import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import MarketingOptInForm from './MarketingOptInForm'
import digitalStoreSdk from '../../../digitalStoreSdk'
import sdk from '../../../digitalStoreSdk'

export default compose(
  connect(),
  withHandlers({
    onSubmit: ({ onSubmissionComplete, customerId, token }) => ({ language }) => {
      return sdk.customers
        .updateGeneralMarketing({
          customerId,
          token,
          language
        })
        .then(() => {
          onSubmissionComplete()
        })
    }
  })
)(MarketingOptInForm)



// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/MarketingOptInForm/index.js